import React from "react";
import { Network, Cpu, ShieldAlert } from "lucide-react";

// The two things every newcomer confuses: the chain and the platform on it.
// Wording tracks what the walkthrough actually asks people to do — nothing aspirational.
const CARDS = [
  {
    key: "botchain",
    icon: Network,
    chip: "The network",
    chipClass: "chip-blue",
    title: "What is BOT Chain?",
    lead: "The blockchain everything here runs on — its own network, not an app. You add it to TP Wallet once, bridge your USDT across from BNB Chain, and from then on your hashrate, your mining rewards and your staking all live on it.",
    points: [
      ["CA", "the token daily mining pays out — it has a floating market price"],
      ["USDT", "what you bring in and what you cash out to, bridged from BNB Chain"],
      ["BNB", "a few dollars covers the gas while you move funds around"],
      ["TP Wallet", "your own wallet holds the keys — BOT Chain is added as a custom network"],
    ],
  },
  {
    key: "carypact",
    icon: Cpu,
    chip: "The platform",
    chipClass: "chip-pink",
    title: "What is CaryPact?",
    lead: "The platform on BOT Chain where you actually participate. You commit USDT to computing power, that computing power mines CA for you daily, and you claim it into your own wallet. Staking and VIP level rewards sit on top.",
    points: [
      ["Buy hashrate", "commit USDT to computing power — this is what starts daily CA mining"],
      ["Claim daily", "rewards accrue every day and you claim them yourself, to your own wallet"],
      ["Stake CA", "flexible (withdraw any time) or fixed-term (higher rate)"],
      ["VIP V1–V10", "levels earned from your own commitment plus your team's — they pay extra rewards"],
    ],
  },
];

export const WhatIs = () => (
  <section className="px-6 md:px-10 mt-20" id="what-is">
    <div className="max-w-[1400px] mx-auto">
      <div className="grid md:grid-cols-2 gap-5">
        {CARDS.map((c, i) => (
          <div key={c.key} id={`what-is-${c.key}`} className="glass p-7 md:p-8 fade-up" style={{ animationDelay: `${i * 0.06}s` }} data-testid={`what-is-${c.key}`}>
            <div className="flex items-center justify-between mb-5">
              <div className="w-11 h-11 rounded-xl flex items-center justify-center" style={{ background: "linear-gradient(135deg, rgba(64,96,255,0.14), rgba(107,138,255,0.08))" }}>
                <c.icon size={20} style={{ color: "var(--primary)" }} />
              </div>
              <span className={`chip ${c.chipClass}`}>{c.chip}</span>
            </div>
            <h2 className="font-display text-3xl font-bold tracking-tight mb-3">{c.title}</h2>
            <p className="text-sm md:text-base text-ink-2 leading-relaxed mb-6">{c.lead}</p>
            <dl className="space-y-3">
              {c.points.map(([k, v]) => (
                <div key={k} className="flex gap-3 items-baseline">
                  <dt className="text-[11px] font-bold uppercase tracking-widest text-ink-3 w-[86px] flex-shrink-0">{k}</dt>
                  <dd className="text-sm text-ink-2 leading-relaxed">{v}</dd>
                </div>
              ))}
            </dl>
          </div>
        ))}
      </div>
      <p className="text-[11px] text-ink-3 mt-4 flex items-start gap-2 max-w-3xl leading-relaxed" data-testid="what-is-disclaimer">
        <ShieldAlert size={13} style={{ color: "#B45309" }} className="flex-shrink-0 mt-0.5" />
        BOT Chain and CaryPact are third-party systems. BotChain CP is an independent affiliate and dashboard — we don&apos;t operate them, don&apos;t custody your funds, and never ask for your seed phrase.
      </p>
    </div>
  </section>
);

export default WhatIs;
